import spherelibUtils from 'spherelib-utils'

const { log } = spherelibUtils.log

const SENSITIVE_METHODS = /^(llm\.proxy|chat\.chatStep)$/

export const requestLog = (name, fn) => {
  return async (ctx, ...args) => {
    const t1 = new Date()
    const logArgs = SENSITIVE_METHODS.test(name) ? '[redacted]' : args.join(', ')

    log(
      'worker-request start',
      `${name}(${logArgs})`,
      `from=${ctx.request.public_key}`,
    )

    try {
      const v = await fn(ctx, ...args)

      const t2 = new Date()
      log(
        'worker-request done',
        name,
        `from=${ctx.request.public_key}`,
        `${t2.getTime() - t1.getTime()}ms`,
      )

      return v
    } catch (err) {
      const t3 = new Date()
      log(
        'worker-request error',
        name,
        `from=${ctx.request.public_key}`,
        err?.message,
        `${t3.getTime() - t1.getTime()}ms`,
      )

      throw err
    }
  }
}
